import { serializeFlow } from "./flowSerializer";
import { FlowSettingsField } from "./flowSchema";

export function buildDiagnosticFlowRequest({
  flowName,
  flowSettings,
  nodes,
  edges,
}) {
  return {
    name: flowName,
    information: flowSettings[FlowSettingsField.INFORMATION] || null,
    jsonFlow: JSON.stringify(serializeFlow(nodes, edges)),
    isActive: flowSettings[FlowSettingsField.IS_ACTIVE],
    laborCodes: flowSettings[FlowSettingsField.LABOR_CODES] || null,
    isDefaultForWarranty: flowSettings[FlowSettingsField.IS_DEFAULT_FOR_WARRANTY],
    outletIds: flowSettings[FlowSettingsField.OUTLET_IDS] || [],
    brandIds: flowSettings[FlowSettingsField.BRAND_IDS] || [],
  };
}
